import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-confirm-rejection-modal',
  templateUrl: './confirm-rejection-modal.component.html',
  styleUrls: ['./confirm-rejection-modal.component.scss']
})
export class ConfirmRejectionModalComponent {




  public data: any;
  endPoint: any;
  payload: any;
  rejectedForm!: FormGroup;
  submitted =false;
  isCommentBoxShow =false

  constructor(private api: SevaProfileService,private fb: FormBuilder,protected dialogRef: NbDialogRef<ConfirmRejectionModalComponent>) {
    // Access the passed data from the dialogRef's context
    this.data = this.dialogRef;  // Use dialogRef.context to access the passed data
  }


  ngOnInit() {
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
    this.isCommentBoxShow = this.data.isCommentBoxShow; // Assuming you need this condition here as well
  
    this.initializeForm();
  }
  
  initializeForm() {
    const commentValidators = this.isCommentBoxShow ? [] : [Validators.required]; // Conditional validators
    this.rejectedForm = this.fb.group({
      comment: ['', commentValidators],
    });
  }
  
  // This method will close the modal with a "true" result
  REJECT() {
    if (!this.isCommentBoxShow && this.rejectedForm.invalid) {
      this.submitted = true;
      this.rejectedForm.markAllAsTouched(); // Highlight invalid fields
      return;
    }
  
    this.submitted = false;
  
    if (!this.isCommentBoxShow) {
      const comment = this.rejectedForm.get('comment')?.value;
      this.payload.FinalRemarks = comment;
    }
  
    this.api.apiCall(this.endPoint, 'POST', this.payload).subscribe((response: any) => {
      if (response.Data) {
        this.dialogRef.close(true); // Pass true to indicate rejection
      }
    });
  }

  // This method will close the modal with a "false" result
  cancel() {
    this.dialogRef.close(false); // Pass false to indicate cancellation
  }
}
